// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_c0-0";
export var orangeButton = "_c0-1";